import { createElement, useState } from "react";
import { Plus } from "lucide-react";
import { ArrayEditor, Cell, Scalar, inp, isNested, isObj, label } from "./json-editor/Fields";

function AddKey({ onAdd, path }) {
  const [k, setK] = useState("");
  const [t, setT] = useState("text");
  const make = () => (t === "number" ? 0 : t === "bool" ? false : t === "list" ? [] : t === "obj" ? {} : "");
  return (
    <div className="flex gap-2 items-center">
      <input data-testid={`json-${path}-newkey`} className={`${inp} max-w-[200px]`} placeholder="nueva_clave" value={k} onChange={(e) => setK(e.target.value.replace(/\s+/g, "_").toLowerCase())} />
      <select className={`${inp} max-w-[120px]`} value={t} onChange={(e) => setT(e.target.value)}>
        <option value="text">texto</option><option value="number">número</option><option value="bool">sí/no</option><option value="list">lista</option><option value="obj">sección</option>
      </select>
      <button data-testid={`json-${path}-addkey`} disabled={!k} onClick={() => { onAdd(k, make()); setK(""); }} className="text-xs text-[#FF7A00] font-semibold disabled:opacity-40 inline-flex items-center gap-1"><Plus size={12} /> agregar clave</button>
    </div>
  );
}

export function JsonEditor({ value, onChange, path = "root", compact = false }) {
  const [open, setOpen] = useState(!compact);
  if (Array.isArray(value)) return createElement(ArrayEditor, { value, onChange, path });
  if (!isObj(value)) return createElement(Scalar, { value, onChange, testid: `json-${path}` });
  const keys = Object.keys(value);
  const removeKey = (k) => { const next = { ...value }; delete next[k]; onChange(next); };
  return (
    <div className={compact ? "rounded-lg border border-border p-2" : "space-y-3"}>
      {compact && <button onClick={() => setOpen(!open)} className="text-[11px] text-[#575757]">{open ? "▾" : "▸"} {keys.length} campos</button>}
      {open && keys.map((k) => (
        <div key={k} className={isNested(value[k]) ? "rounded-xl bg-[#FAF8F5] p-3" : ""}>
          <div className="flex items-center justify-between">
            <div className="text-xs font-semibold text-[#575757] mb-1">{label(k)}</div>
            {isNested(value[k]) && !compact && <button onClick={() => removeKey(k)} className="text-[10px] text-[#8A8A8A] hover:text-red-600">quitar sección</button>}
          </div>
          {createElement(Cell, { value: value[k], onChange: (v) => onChange({ ...value, [k]: v }), path: `${path}.${k}`, testid: `json-${path}-${k}` })}
        </div>
      ))}
      {open && !compact && <AddKey onAdd={(k, v) => onChange({ ...value, [k]: v })} path={path} />}
    </div>
  );
}
